// extracted by mini-css-extract-plugin
module.exports = {"img-text-card-box":"ey","imgTextCardBox":"ey","text-box":"ez","textBox":"ez","remark-val":"eA","remarkVal":"eA"};